<template>
  <div class="row">
    <div class="col-xl-6 col-lg-7 col-md-9 mx-auto">
      <h3>Xert Authentication</h3>
      <form @submit.prevent="submitHandler()" autocomplete="off">
        <div class="form-group">
          <label for="password">Username</label>
          <input
            type="text"
            v-model="form.username"
            class="form-control"
            id="username"
            placeholder="Enter Username"
            autocomplete="chrome-off"
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            type="password"
            v-model="form.password"
            class="form-control"
            id="password"
            placeholder="Enter Password"
            autocomplete="chrome-off"
          />
        </div>
        <div style="clear: both"></div>
        <button type="submit" class="btn-universal cursor-pointer">
          Connect
        </button>
        <button
          @click="onCancel"
          class="btn-universal btn-register-cancel cursor-pointer ml-3"
        >
          Cancel
        </button>
      </form>
      <div class="mt-3">
        If you don't have an account, you can create one.
        <a href="https://xertonline.com/auth" target="_blank">here</a>. and come
        back here to connect.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  name: "XertAuthentication",

  data() {
    return {
      form: {
        username: "",
        password: "",
        network: "xert",
      },
    };
  },

  validations: {
    form: {
      username: { required },
      password: { required },
    },
  },

  computed: {
    ...mapGetters("auth", ["user", "loggedIn"]),
    ...mapGetters(["errors"]),
  },
  emits: ["connectionDone", "onCancel"],
  methods: {
    async submitHandler() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.dispatch("oauth/authorization", this.form).then((res) => {
        if (res && res.status) {
          this.$emit("connectionDone", res);
          return;
        }
        alert("An error has occurred. Please try again");
        this.$emit("connectionDone");
      });

      this.form.password = null;
      this.form.username = null;
    },

    getError(field) {
      return this.$v.form[field].$invalid;
    },

    onCancel() {
      this.$emit("onCancel");
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.text-danger {
  font-size: 12px;
}
</style>
